import styled from "styled-components";

export const ContainerHeader = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    gap: 17px;
    border-radius: 4px;
    border: 1px solid #D8DCDE;
    background-color: white;
`

export const ContainerTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    h1{
        color: #414141;
        font-size: 24px;
        font-weight: 500;
    }
`
export const ContainerButtons = styled.div`
    display: flex;
    justify-content: center;
    gap: 16px;

    .btntutotial{
        background: none;
        border: none;
        cursor: pointer;
    }
`

export const ContainerBigNumbers = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 16px;
`